import { render, staticRenderFns } from "./ItemCombobox.vue?vue&type=template&id=c002f63a&scoped=true"
import script from "./ItemCombobox.vue?vue&type=script&lang=js"
export * from "./ItemCombobox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c002f63a",
  null
  
)

export default component.exports